// administrators log in via the hosted ui
import axios from 'axios'
import qs from 'querystring'
import store from './store';

export default {
  domainUrl: 'https://illusx-admin.auth.us-east-1.amazoncognito.com',
  getCallbackUrl: function () {
    return window.location.protocol + '//' + window.location.host
  },
  isSignedIn: async function () {
    if(localStorage.auth_id_token && localStorage.auth_expiry) {
      let time = Math.round(new Date().getTime() / 1000)
      let expiry = Number(JSON.parse(localStorage.auth_expiry))
      
      if (expiry < time) {
        // check refresh token
        if(localStorage.auth_refresh_token) {
          return await this.refreshToken()
        }
      }
      else {
        store.commit('setAdminToken', localStorage.auth_id_token)
        return true
      }
    }
    return false
  },
  refreshToken: async function () {
    let appId = process.env.VUE_APP_COGNITO_ID
    let data = qs.stringify({
      grant_type: 'refresh_token',
      client_id: appId,
      refresh_token: localStorage.auth_refresh_token
    })
    try {
      const url = `${this.domainUrl}/oauth2/token`
      console.log('posting to', url)
      let res = await axios.post(url, data,
        {
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      // this.storeTokens(res.data) // NO because no new refresh token will be sent
      localStorage.auth_id_token = res.data.id_token
      store.commit('setAdminToken', res.data.id_token)
      this.setExpiry(res.data.expires_in)
      return true
    }
    catch(err) {
      console.log(err)
    }
    return false
  },
  storeTokens: function (data) {
    localStorage.auth_id_token = data.id_token
    localStorage.auth_refresh_token = data.refresh_token
    this.setExpiry(data.expires_in)
  },
  setExpiry: function (val) {
    let exp = Number(val)
    let expiry = Math.round(new Date().getTime() / 1000) + exp
    localStorage.auth_expiry = JSON.stringify(expiry)
  },
  getParsedHash: function (routerHash) {
    let hash = routerHash.substring(1)
    let items = hash.split('&')
    let ps = {}
    for(let item of items) {
      let spl = item.split('=')
      ps[spl[0]] = spl[1]
    }
    return ps
  }
}
